import { Injectable } from '@angular/core';

import { Client } from 'src/providers/client/client';

@Injectable()
export class AboutThisPageService {

  private readonly STORAGE_KEY = 'aboutThisPageData';
  private readonly METADATA_KEY = 'aboutThisPage.data';
  private readonly GET_METADATA_KEY = 'external.aboutThisPage.data';
  private readonly ALL_PAGES = [
    'strategy', 'monthly-pl', 'schedule', 'messages', 'bills', 'restocking',
    'maintenance', 'assets', 'checklists', 'upsells', 'pros',
    'guests', 'messageAutomation', 'upsell', 'noise-monitoring',
    'transactions', 'taxes', 'properties', 'access',
    'listings', 'reviews', 'guidebook',
    'wifi-marketing', 'compliance', 'insurance', 'direct-booking'
  ];

  constructor(
    private client: Client
  ) {}

  checkIfShouldShowAboutThisPage(page: string): boolean {
    // Rental clients never see the "About this page" prompt takeover on any page.
    if (localStorage.getItem('isRentalClient') === 'true') {
      return false;
    }
    const data = localStorage.getItem(this.STORAGE_KEY);
    if (!data) {
      return false;
    }
    const pageMap = this.parseDataString(data);
    return pageMap[page] !== 'false';
  }

  async dismissAboutThisPage(page: string): Promise<void> {
    const data = localStorage.getItem(this.STORAGE_KEY) || this.getDefaultDataString();
    const pageMap = this.parseDataString(data);
    pageMap[page] = 'false';
    const newDataString = this.buildDataString(pageMap);
    localStorage.setItem(this.STORAGE_KEY, newDataString);
    await this.client.addMetadata({ key: this.METADATA_KEY, value: newDataString });
  }

  async fetchAndStoreAboutThisPageData(): Promise<void> {
    if (localStorage.getItem(this.STORAGE_KEY)) {
      return;
    }
    try {
      const metadata = await this.client.getMetadata([this.GET_METADATA_KEY]);
      const dataString = metadata?.[0]?.value || this.getDefaultDataString();
      localStorage.setItem(this.STORAGE_KEY, dataString);
    } catch (error) {
      localStorage.setItem(this.STORAGE_KEY, this.getDefaultDataString());
    }
  }

  private parseDataString(data: string): Record<string, string> {
    const result: Record<string, string> = {};
    const pairs = data.split(',');
    for (const pair of pairs) {
      const [key, value] = pair.split(':');
      if (key && value !== undefined) {
        result[key.trim()] = value.trim();
      }
    }
    return result;
  }

  private buildDataString(pageMap: Record<string, string>): string {
    return Object.entries(pageMap)
      .map(([key, value]) => `${key}:${value}`)
      .join(',');
  }

  private getDefaultDataString(): string {
    return this.ALL_PAGES.map(page => `${page}:true`).join(',');
  }
}
